<template>
    <div :style="{position: 'fixed', left: left+'px', top: top+'px', width:width+'px', height: height+'px', border: 'solid 2px yellow'}">
    </div>
</template>

<script>
    export default {
        props: ['left','top','width','height']
    }
</script>